import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';

// Material components
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';

// Custom components
import Notifications from './components/Notifications';

//import Password from './components/Password';
import Profile from './components/Profile';
import Addressee from './components/Addressee';
import UsersList from './components/UsersList';
import GroupsList from './components/GroupsList';
import AlertsHours from './components/AlertsHours';
import TemplateManager from './components/TemplateManager';
import AddreesseExtendend from './components/AddresseeExtended';
import { Box } from '@material-ui/core';
//import Configuration from './components/Configuration';

// Component styles
const styles = theme => ({
    root: {
        //Custom Styles AP
        backgroundColor: '#e7e7e7',
        height: '100vh'
    }
});

class Settings extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.state = {
            tabIndex: 0,
            props: props,
            value: 0,
            profileId: sessionStorage.getItem('profile_id'),
            listAdreesses: [1,2,5],
            listUsers: [1],
            listGroups: [1],
            listHours: [1,2,5]
        }
    }

    myCallback = (dataFromChild) => {
        
        this.setState({
            objectivesList: dataFromChild
        })
    }

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
            //updateDisabled: true,
            //alertobjectives: null
        });
    };

    render() {
        const { classes, t } = this.props;
        const {value, profileId, listAdreesses, listUsers, listGroups, listHours} = this.state;
        var disabledAdreesses = true
        var disabledUsers = true
        var disabledGroups = true
        var disabledHours = true
        if(listAdreesses.includes(parseInt(profileId)) === true){
            disabledAdreesses = false
        }
        if(listUsers.includes(parseInt(profileId)) === true){
            disabledUsers = false
        }
        if(listGroups.includes(parseInt(profileId)) === true){
            disabledGroups = false
        }
        if(listHours.includes(parseInt(profileId)) === true){
            disabledHours = false
        }
        return (
            <DashboardLayout title={t('settings.title')} callbackFromParent={this.myCallback} >
                <div className={classes.root} style={{height: '100%'}}>
                    <AppBar position="static"  style={{ backgroundColor: '#333333'}}>
                        <Tabs value={value} variant='scrollable' onChange={this.handleChange} aria-label="simple tabs example">
                            <Tab label={t('settings.tabs.profile')}  />
                            <Tab label={t('settings.tabs.contacts')} disabled={disabledAdreesses}/>
                            <Tab label={t('settings.tabs.contactsExtended')} />
                            <Tab label={t('settings.tabs.users')} disabled={disabledUsers}/>
                            <Tab label={t('settings.tabs.groups')} disabled={disabledGroups}/>
                            <Tab label={t('settings.tabs.alertsHours')} disabled={disabledHours}/>
                            <Tab label={t('settings.tabs.templates')} disabled={disabledHours}/>
                        </Tabs>
                    </AppBar>
                    { value == 0 ? 
                        <div style={{padding: 20}}>
                            <Profile/>
                        </div>
                    : value == 1 ?
                        <div style={{padding: 20}}>
                            <Addressee/>
                        </div>
                    : value == 2 ?
                        <div style={{padding: 20}}>
                            <AddreesseExtendend/>
                        </div>
                    : value == 3 ?
                        <div style={{padding: 20}}>
                            <UsersList/>
                        </div>
                    : value == 4 ?
                        <div style={{padding: 20}}>
                            <GroupsList/>
                        </div>
                    : value == 5 ?
                        <div style={{padding: 20}}>
                            <AlertsHours/>
                        </div>
                    :  value == 6 ?
                        <div style={{padding: 20}}>
                            <TemplateManager/>
                        </div>
                : null }
                </div>
            </DashboardLayout>
        );
    }
}

Settings.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withTranslation()(withStyles(styles)(Settings));
